import { useEffect, useState } from 'react'

import Api from 'services/api'

import FeatureTour from 'types/FeatureTour'

const useFeatureTours = (brands, getPublishedOnly, refreshTimestamp) => {
  const [featureTours, setFeatureTours] = useState<Array<FeatureTour>>([])
  const [areFeatureToursLoaded, setAreFeatureToursLoaded] = useState(false)

  useEffect(() => {
    setAreFeatureToursLoaded(false)

    Api.FeatureTours.list(brands, getPublishedOnly)
      .then((res) => {
        setFeatureTours(res)
        setAreFeatureToursLoaded(true)
      })
      .catch(() => {
        setFeatureTours([])
        setAreFeatureToursLoaded(true)
      })
  }, [getPublishedOnly, refreshTimestamp]) // eslint-disable-line react-hooks/exhaustive-deps

  return { featureTours, areFeatureToursLoaded }
}

export default useFeatureTours
